module.exports = __webpack_public_path__ + "static/Google-Sheets-Export-f226972d213e47eab59302f68ed58160.svg";